import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-form-section',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="page-form-section">
      <div class="section-header">
        <div class="section-heading">
          @if (icon) {
            <i [class]="icon"></i>
          }
          <div>
            <h2>{{ title }}</h2>
            @if (subtitle) {
              <p>{{ subtitle }}</p>
            }
          </div>
        </div>
        <div class="section-actions">
          <ng-content select="[actions]"></ng-content>
        </div>
      </div>
      <ng-content></ng-content>
    </section>
  `,
  styles: [`
    .page-form-section {
      min-width: 0;
      padding: 1rem;
      border: 1px solid var(--app-border, #dfe7f3);
      border-radius: 8px;
      background: var(--app-surface, #ffffff);
      box-shadow: 0 10px 24px var(--app-shadow-soft, rgba(15, 23, 42, 0.05));
    }

    .section-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 0.75rem;
      margin-bottom: 1rem;
    }

    .section-heading {
      display: flex;
      align-items: flex-start;
      min-width: 0;
      gap: 0.75rem;
    }

    .section-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-shrink: 0;
    }

    .section-heading i {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 2.25rem;
      height: 2.25rem;
      color: var(--app-accent-strong, #0f766e);
      background: var(--app-accent-surface, #ecfdf5);
      border-radius: 8px;
    }

    h2 {
      color: var(--app-text, #172033);
      font-size: 1.15rem;
      margin: 0;
    }

    p {
      color: var(--app-muted, #64748b);
      margin: 0.35rem 0 0;
    }

    @media (max-width: 560px) {
      .page-form-section {
        padding: 0.85rem;
      }

      .section-header {
        align-items: stretch;
        flex-direction: column;
      }

      .section-actions {
        justify-content: flex-start;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageFormSectionComponent {
  @Input() icon = '';
  @Input() title = '';
  @Input() subtitle = '';
}
